import { SERVICE } from './constants'

export const SHOW = `${SERVICE}/SHOW`
export const HIDE = `${SERVICE}/HIDE`
export const SHOW_CONFIRMATION = `${SERVICE}/SHOW_CONFIRMATION`
export const HIDE_CONFIRMATION = `${SERVICE}/HIDE_CONFIRMATION`

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR'
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR'
export const SET_SNACKBARS = 'SET_SNACKBARS'
export const RESET_SNACKBARS = 'RESET_SNACKBARS'
